import {HttpModule} from '@angular/http';
import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';

interface Pergunta {
  id: string;
  title?: string;
  original_title: string;
  fieldType: string;
  fieldValue?: string;
  required: boolean;
  description?: string;
  placeholder?: string;
  mask ?: string;
  visible?: boolean;
  invalid?: boolean;
  regex?: string;
  valid?: boolean;
  conditional?: { if: string, goto: string }[];
  fieldOptions ?: { option_title: string, option_value: string, image?: string }[];
  callback?: (simulador: Simulador, pergunta: Pergunta, http: HttpClient, router: Router) => void;
  botaoDesc?: string;
}

export class Simulador {
  index  = false;
  form   = false;
  voltar = false;

  usuario = {
    nome: '',
    email: ''
  };

  facebook = {
    id: '',
    image: '',
    token: ''
  };

  variaveis: any = {
    nesse: 'Nesse',
    email: '',
    telefone: '',
    local: 'o',
    seu_estabelecimento: 'seu',
    um_estabelecimento: 'um',
    estabelecimento: 'estabelecimento',
    n_profissionais: '1',
    x_profissionais: '1',
    dias_opera: 1,
    dias: 'dias',
    pessoas_atendidas: [0, 10],
    atendimento_media_clientes_mes: [0, 0],
    telefonemas_atendidas: [0, 10],
    telefonemas_atendidas_mes: [0, 0]
  };

  formulario: Pergunta[] = [
    {
      'id': '1',
      'original_title': 'Por favor, qual o seu nome?  ',
      'fieldType': 'textfield',
      'fieldValue': '',
      'required': true,
      'description': '',
      'placeholder': 'Márcia'
    },
    {
      'id': '1xa',
      'original_title': '[[1]], nos informe seu sobrenome completo, para que possamos te identificar no sistema: *',
      'fieldType': 'textfield',
      'fieldValue': '',
      'required': true,
      'description': '',
      'placeholder': 'Da silva'
    },
    {
      'id': '3',
      'original_title': '[[1]], agora por favor nos diga, qual o seu melhor telefone para contato?',
      'fieldType': 'textfield',
      'fieldValue': '',
      'required': true,
      'placeholder': '(00) 0 0000-0000',
      'mask': '(00) 0 0000-0000',
      'regex': '\\(\\d\\d\\) \\d \\d\\d\\d\\d-\\d\\d\\d\\d',
    },
    {
      'id': '3xa',
      'original_title': '[[1]], qual o seu CEP? *',
      'fieldType': 'textfield',
      'fieldValue': '',
      'required': true,
      'placeholder': '00000-000',
      'mask': '00000-000',
      'regex': '\\d\\d\\d\\d\\d\\-\\d\\d\\d',
    },
    {
      'id': '2',
      'original_title': '[[1]], informe também qual o seu melhor e-mail para entrarmos em contato? *',
      'fieldType': 'textfield',
      'fieldValue': '',
      'required': true,
      'description': '',
      'placeholder': 'seu@email.com',
      'regex': '(?:[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\\])',
      'callback': function (simulador, pergunta) {
        delete simulador.variaveis.email;
        simulador.variaveis.email = pergunta.fieldValue;
      }
    },
    {
      'id': '4',
      'original_title': 'Agora que temos seus dados para contato, vamos seguir com o questionário! Precisamos saber um pouco mais sobre você, continue sendo correto em suas respostas, ok?',
      'fieldType': 'statement',
      'required': false,
      'description': ''
    },
    {
      'id': '3xaa',
      'original_title': 'Qual sua idade? *',
      'fieldType': 'textfield',
      'fieldValue': '',
      'required': true,
      'placeholder': '00',
      'mask': '00',
      'regex': '\\d\\d',
    },
    {
      'id': '5',
      'original_title': 'Qual seu grau de escolaridade? *',
      'required': true,
      'fieldType': 'radio',
      'fieldValue': '',
      'fieldOptions': [
        {
          'option_title': 'A',
          'option_value': 'Segundo Grau Incompleto',
        },
        {
          'option_title': 'A',
          'option_value': 'Segundo Grau Completo',
        },
        {
          'option_title': 'A',
          'option_value': 'Graduação Incompleta',
        },
        {
          'option_title': 'A',
          'option_value': 'Graduação Completa',
        },
        {
          'option_title': 'A',
          'option_value': 'Pós Graduação',
        },
      ],
      'conditional': [
        {if: 'Segundo Grau Completo', goto: '3x5aa'},
        {if: 'Graduação Incompleta', goto: '3x5aa'},
        {if: 'Graduação Completa', goto: '3x5aa'},
        {if: 'Pós Graduação', goto: '3x5aa'},
      ]
    },
    {
      'id': '4lojk',
      'original_title': 'Para ser uma Secretária Virtual um de nossos pré-requisitos é ter formação superior completa, porem você poderá terminar de responder o questionário.',
      'fieldType': 'statement',
      'required': false,
      'description': '',
      'conditional': [
        {if: null, goto: '5za132'},
      ]
    },
    {
      'id': '3x5aa',
      'original_title': 'Qual a sua formação?',
      'fieldType': 'textfield',
      'fieldValue': '',
      'required': true,
      'placeholder': 'Descreva os cursos que você fez na graduação e pós-graduação.',
    },
    {
      'id': '5za132',
      'original_title': '[[1]], para ser uma mini-franquia da Secretária Virtual, você tem ciência que trabalhará sempre em casa, "home office"? O que você acha disso? *',
      'required': true,
      'fieldType': 'radio',
      'fieldValue': '',
      'fieldOptions': [
        {
          'option_title': 'A',
          'option_value': 'Sim! É perfeito. Me adapto muito bem trabalhando em casa.',
        },
        {
          'option_title': 'A',
          'option_value': 'Não sabia disso. Não irei me adaptar!',
        }
      ],
      'conditional': [
        {if: 'Sim! É perfeito. Me adapto muito bem trabalhando em casa.', goto: '6'},
      ]
    },
    {
      'id': '5za132jk',
      'original_title': '[[1]], para se tornar uma mini-franquia da Secretária Virtual você terá que trabalhar de casa e ter um ambiente adequado para isso. Você poderá continuar a responder o questionário se houver interesse em fazer parte da Secretária Virtual.',
      'fieldType': 'statement',
      'required': false,
      'description': ''
    },
    {
      'id': '6',
      'original_title': '[[1]], como uma mini-franquia, você tem ciência de que será uma micro empresa? *',
      'required': true,
      'fieldType': 'radio',
      'fieldValue': '',
      'fieldOptions': [
        {
          'option_title': 'A',
          'option_value': 'Sim. Sei que receberei de acordo com minha produção de trabalho.',
        },
        {
          'option_title': 'B',
          'option_value': 'Não. Meu objetivo é ser funcionário de uma empresa com salário e horários fixos.',
        },
      ],
      'conditional': [
        {if: 'Sim. Sei que receberei de acordo com minha produção de trabalho.', goto: '7'},
      ]
    },
    {
      'id': '6jk',
      'original_title': '[[1]], infelizmente o negócio Secretária Virtual não se adequa a seus objetivos. Caso tenha interesse, você poderá continuar a responder este questionário.',
      'fieldType': 'statement',
      'required': false,
      'description': ''
    },
    {
      'id': '7',
      'original_title': '[[1]], você entende que sendo uma micro empresa, não trabalhará para a Secretária Virtual como uma funcionária ou colaboradora, e sim com uma franquia parceira e prestadora de serviço? *',
      'required': true,
      'fieldType': 'radio',
      'fieldValue': '',
      'fieldOptions': [
        {
          'option_title': 'A',
          'option_value': 'Sim, estou de acordo.',
        },
        {
          'option_title': 'B',
          'option_value': 'Não, não é isso que estou buscando.',
        },
      ],
      'conditional': [
        {if: 'Sim, estou de acordo.', goto: '8'},
      ]
    },
    {
      'id': '7jk',
      'original_title': '[[1]], infelizmente o negócio Secretária Virtual não se adequa a seus objetivos. Caso tenha interesse, você poderá continuar a responder este questionário.',
      'fieldType': 'statement',
      'required': false,
      'description': ''
    },
    {
      'id': '8',
      'original_title': 'Entende que o sistema de franquia existe para a transferência de conhecimento e tecnologia? Que a partir do momento que se tornar uma Secretária Virtual, passará a representar a marca Secretária Virtual, bem como todos os seus recursos e princípios? *',
      'required': true,
      'fieldType': 'radio',
      'fieldValue': '',
      'fieldOptions': [
        {
          'option_title': 'A',
          'option_value': 'Sim, estou de acordo.',
        },
        {
          'option_title': 'B',
          'option_value': 'Não, não tenho interesse.',
        },
      ],
      'conditional': [
        {if: 'Sim, estou de acordo.', goto: '9'},
      ]
    },
    {
      'id': '8jk',
      'original_title': '[[1]], infelizmente o negócio Secretária Virtual não se adequa a seus objetivos. Caso tenha interesse, você poderá continuar a responder este questionário.',
      'fieldType': 'statement',
      'required': false,
      'description': ''
    },
    {
      'id': '9',
      'original_title': 'Entende que para ser uma micro empresa, investimentos de tempo em treinamento, investimento financeiro em aquisição de equipamentos e taxas serão necessários? *',
      'required': true,
      'fieldType': 'radio',
      'fieldValue': '',
      'fieldOptions': [
        {
          'option_title': 'A',
          'option_value': 'Sim, tenho interesse em adquirir uma mini franquia.',
        },
        {
          'option_title': 'B',
          'option_value': 'Não, pensei que fosse diferente. Não tenho interesse.',
        },
      ],
      'conditional': [
        {if: 'Sim, tenho interesse em adquirir uma mini franquia.', goto: '10'},
      ]
    },
    {
      'id': '9jk',
      'original_title': '[[1]], infelizmente o negócio Secretária Virtual não se adequa a seus objetivos. Caso tenha interesse, você poderá continuar a responder este questionário.',
      'fieldType': 'statement',
      'required': false,
      'description': ''
    },
    {
      'id': '10',
      'original_title': 'Muito bem [[1]], a partir de agora, as próximas perguntas tem a finalidade de sabermos se você tem o perfil "técnico" necessário para se tornar uma franquia da Secretária Virtual.\n' +
        'Continue respondendo o mais precisamente possível, vamos seguir? *',
      'required': true,
      'fieldType': 'radio',
      'fieldValue': '',
      'fieldOptions': [
        {
          'option_title': 'A',
          'option_value': 'Sim!',
        },
        {
          'option_title': 'B',
          'option_value': 'Não tenho mais interesse.',
        },
      ],
      'conditional': [
        {if: 'Sim!', goto: '11'},
      ]
    },
    {
      'id': '9jk',
      'original_title': '[[1]], infelizmente o negócio Secretária Virtual não se adequa a seus objetivos. Caso tenha interesse, você poderá continuar a responder este questionário.',
      'fieldType': 'statement',
      'required': false,
      'description': ''
    },
    {
      'id': '11',
      'original_title': 'Para ser uma Secretária Virtual, você precisa ter acesso a internet de qualidade em casa, poderia nos dizer qual é sua internet? *',
      'required': true,
      'fieldType': 'radio',
      'fieldValue': '',
      'fieldOptions': [
        {
          'option_title': 'A',
          'option_value': 'ADSL (linha telefonica comum)',
        },
        {
          'option_title': 'B',
          'option_value': 'Fibra Ótica',
        },
        {
          'option_title': 'C',
          'option_value': 'Cabo de TV',
        },
        {
          'option_title': 'D',
          'option_value': 'Rádio',
        },
        {
          'option_title': 'E',
          'option_value': '3G ou 4G',
        },
      ],
      'conditional': [
        {if: 'Cabo de TV', goto: '12'},
        {if: 'Fibra Ótica', goto: '12'},
      ]
    },
    {
      'id': '11jk',
      'original_title': '[[1]], a sua conexão de internet não está apta para os padrões dos serviços da Secretária Virtual. É necessário uma internet de no mínimo 30 MB (preferencialmente Fibra Ótica ou Cabo de TV), porem você poderá terminar de responder o questionário.',
      'fieldType': 'statement',
      'required': false,
      'description': ''
    },
    {
      'id': '12',
      'original_title': ' queremos saber um pouco mais sobre você. Conte-nos: É casada? Tem filho? Quantos? Qual a idade deles? O que seu esposo faz? Mora de aluguel ou possui residência própria? Possui animais de estimação? Qual? *',
      'fieldType': 'textfield',
      'fieldValue': '',
      'required': true,
      'placeholder': 'É importante que você descreva todas as perguntas que fizemos aqui.',
    },
    {
      'id': '13',
      'original_title': 'Possui em casa um ambiente exclusivo para seu novo negócio? (uma sala separada, ou um quarto, onde poderá montar sua estrutura de trabalho).\n' +
        'Possui em casa um ambiente exclusivo para seu novo negócio? (uma sala separada, ou um quarto, onde poderá montar sua estrutura de trabalho). *\n' +
        '<p><small>Não pode ser em cômodos onde existe circulação constante de pessoas ou televisão ligada.</small></p>',
      'required': true,
      'fieldType': 'radio',
      'fieldValue': '',
      'fieldOptions': [
        {
          'option_title': 'A',
          'option_value': 'Sim',
        },
        {
          'option_title': 'B',
          'option_value': 'Não',
        },
      ],
      'conditional': [
        {if: 'Sim', goto: '14'},
      ]
    },
    {
      'id': '13jk',
      'original_title': '[[1]], para atender como Secretária Virtual é necessário que você possua um ambiente silencioso para trabalhar, sem interrupções.',
      'fieldType': 'statement',
      'required': false,
      'description': ''
    },
    {
      'id': '14',
      'original_title': 'Quase acabando, [[1]]! Por favor, nos confirme seu telefone: [[3]] e seu e-mail: [[2]]. Assim quando nossa equipe finalizar a analise de seu questionário, possamos entrar em contato. *',
      'required': true,
      'fieldType': 'radio',
      'fieldValue': '',
      'fieldOptions': [
        {
          'option_title': 'A',
          'option_value': 'Esta Correto!',
        },
        {
          'option_title': 'B',
          'option_value': 'Preciso alterar.',
        },
      ],
      'conditional': [
        {if: 'Esta Correto!', goto: '17'},
      ]
    },
    {
      'id': '15',
      'original_title': '[[1]], agora por favor nos diga, qual o seu melhor telefone para contato, com DDD, ok *',
      'fieldType': 'textfield',
      'fieldValue': '',
      'required': true,
      'placeholder': '(00) 0 0000-0000',
      'mask': '(00) 0 0000-0000',
      'regex': '\\(\\d\\d\\) \\d \\d\\d\\d\\d-\\d\\d\\d\\d',
    },
    {
      'id': '16',
      'original_title': '[[1]], informe também qual o seu melhor e-mail para entrarmos em contato? *',
      'fieldType': 'textfield',
      'fieldValue': '',
      'required': true,
      'description': '',
      'placeholder': 'seu@email.com',
      'regex': '(?:[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\\])',
    },
    {
      'id': '17',
      'original_title': '[[1]], você tem total entendimento de que está buscando um negócio completamente autônomo e que representará uma marca forte! Trabalhará sem subordinação e sem horário definido, e que após analise, caso seja apta a se tornar uma Secretária Virtual, deverá se dedicar em treinamento, para que somente após aprovação se tornar de fato uma Secretária Virtual? *',
      'required': true,
      'fieldType': 'radio',
      'fieldValue': '',
      'fieldOptions': [
        {
          'option_title': 'A',
          'option_value': 'Sim',
        },
        {
          'option_title': 'B',
          'option_value': 'Não',
        },
      ]
    },
    {
      'id': '18',
      'original_title': '[[1]], por fim, você tem ciência de que mesmo seguindo os padrões de qualificação da Secretária Virtual e passando pelo treinamento, poderá não se tornar uma franqueada caso seja verificado que você não tenha aptidão técnica?',
      'required': true,
      'fieldType': 'radio',
      'fieldValue': '',
      'fieldOptions': [
        {
          'option_title': 'A',
          'option_value': 'Sim',
        },
        {
          'option_title': 'B',
          'option_value': 'Não',
        },
      ]
    },
  ];
}
